import type { CompetitorFiltersInput } from "@/lib/queries/dashboard.queries";
import type { DrilldownPageFiltersInput } from "@/lib/queries/drilldown.queries";

/**
 * Query string for a competitors Drilldown data request. Shared by `/drilldown/data`
 * and `/dashboard/creatives`, which read the same cache entry for the same string.
 */
export function buildDrilldownQs(
  filters: CompetitorFiltersInput,
  drilldownFilters: DrilldownPageFiltersInput,
  offset: number,
): string {
  const qs = new URLSearchParams({ mode: "competitors", dateRange: filters.dateRange });
  if (filters.myIndustry) qs.set("myIndustry", filters.myIndustry);
  if (filters.myBrand) qs.set("myBrand", filters.myBrand);
  if (filters.industryProducts.length > 0) qs.set("industryProducts", filters.industryProducts.join(","));
  if (filters.competitorsIndustry) qs.set("competitorsIndustry", filters.competitorsIndustry);
  if (filters.mainCompetitor) qs.set("mainCompetitor", filters.mainCompetitor);
  if (filters.benchmark.length > 0) qs.set("benchmark", filters.benchmark.join(","));
  // Always send platforms (even empty) — see dashboard.queries for the rationale.
  qs.set("platforms", filters.platforms.join(","));
  // Page filters.
  qs.set("objectType", drilldownFilters.objectType.length > 0 ? drilldownFilters.objectType.join(",") : "All");
  qs.set("effectiveStatus", drilldownFilters.effectiveStatus.length > 0 ? drilldownFilters.effectiveStatus.join(",") : "All");
  if (drilldownFilters.startDate) qs.set("startDate", drilldownFilters.startDate);
  if (drilldownFilters.endDate) qs.set("endDate", drilldownFilters.endDate);
  qs.set("segment1", drilldownFilters.segment1);
  qs.set("segment2", drilldownFilters.segment2);
  qs.set("segment3", drilldownFilters.segment3);
  qs.set("sortMode", drilldownFilters.sortMode);
  qs.set("sortDirection", drilldownFilters.sortDirection);
  if (drilldownFilters.advancedFilters.length > 0) {
    qs.set("advancedFilters", JSON.stringify(drilldownFilters.advancedFilters));
  }
  qs.set("offset", String(offset));
  return qs.toString();
}
